import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = process.env.REACT_APP_ENDPOINT;

// Async thunk to fetch test drive data
export const fetchTestDrive = createAsyncThunk(
  "test-drive-booking",
  async (_, { getState, rejectWithValue }) => {
    try {
      const token = getState().auth.token || localStorage.getItem("authToken");

      if (!token) {
        return rejectWithValue("Token not found");
      }

      const response = await axios.get(`${API_URL}/test-drive-booking`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data.data.data;
    } catch (error) {
      console.error("Error fetching test drive data:", error);
      return rejectWithValue(
        error.response?.data || "Failed to fetch test drive data"
      );
    }
  }
);

export const createTestDriveBooking = createAsyncThunk(
  'test-drive-booking/store', 
  async (items, { getState, rejectWithValue }) => {
      try {
          const token = getState().auth.token || localStorage.getItem('authToken');

          const response = await axios.post(`${API_URL}/test-drive-booking/store`, items, {
              headers: {
                  Authorization: `Bearer ${token}`,
              },
          });

          return response.data;
      } catch (error) {
          console.error('Error store test drive booking:', error);
          return rejectWithValue(error.response?.data || 'Failed to store items');
      }
  }
);

export const updateStatus = createAsyncThunk(
  'test-drive-booking/update-status', 
  async (items, { getState, rejectWithValue }) => {
      try {
          const token = getState().auth.token || localStorage.getItem('authToken');

          const response = await axios.put(`${API_URL}/test-drive-booking/update-status/${items.test_drive_id}`, items, {
              headers: {
                  Authorization: `Bearer ${token}`,
              },
          });

          return response.data;
      } catch (error) {
          console.error('Error update test drive booking:', error);
          return rejectWithValue(error.response?.data || 'Failed to update items');
      }
  }
);

// Redux slice
const testDriveSlice = createSlice({
  name: "testDrive",
  initialState: {
    test_drive_booking: [],
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTestDrive.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchTestDrive.fulfilled, (state, action) => {
        state.isLoading = false;
        state.test_drive_booking = action.payload;
      })
      .addCase(fetchTestDrive.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(createTestDriveBooking.fulfilled, (state, action) => {
          state.test_drive_booking.push(action.payload.ress.data);
      })
      .addCase(updateStatus.fulfilled, (state, action) => {
          const index = state.test_drive_booking.findIndex((item) => item.test_drive_id === action.payload.data.test_drive_id);
          if (index !== -1) {
              state.test_drive_booking[index] = { ...state.test_drive_booking[index], ...action.payload.data };
          }
          state.isLoading = false;
      });
  },
});

export default testDriveSlice.reducer;
